import React from 'react';
import { findDOMNode } from 'react-dom';

import cls from 'classnames/bind';

import Autocomplete from '@ott/autocomplete-deprecated';
import { InputWithRef } from '@ott/input-next-deprecated';

import setRefs from '../utilities/setRefs';

import styles from './CardAutocomplete.scss';

const cx = cls.bind(styles);

class CardAutocomplete extends Autocomplete {
  static propTypes = {
    ...Autocomplete.propTypes,
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.refsMap = {};

    this.state = {
      hasTopShadow: false,
    };

    this.setDropdownShadowsState = this.setDropdownShadowsState.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value,
      activeOption: null,
    });
  }

  getTriggerProps() {
    const { icon, format, parse } = this.props;
    return {
      ...super.getTriggerProps(),
      'data-error-placement': 'bottom',
      icon,
      format,
      parse,
    };
  }

  handleFocus = () => {
    if (!this.state.isOpen) {
      this.setState({
        hasTopShadow: false,
      });
    }

    return super.handleFocus();
  };

  handleBlur = (e, ...args) => {
    this.setState({
      hasTopShadow: false,
    });

    const relatedTarget =
      e &&
      (e.relatedTarget /* Chrome */ ||
        e.srcElement ||
        document.activeElement /* IE */ ||
        e.explicitOriginalTarget); /* Firefox */

    const dropdownNode = findDOMNode(this.refsMap.dropdown);

    if (!relatedTarget || !dropdownNode || !dropdownNode.contains(relatedTarget)) {
      return super.handleBlur(e, args);
    }
  };

  handleChange = (value) => {
    this.setState({
      hasTopShadow: false,
    });

    this.props.onChange(value);

    return super.handleChange(value);
  };

  setDropdownShadowsState = (e, ...args) => {
    const scrollWrapperNode = (e && e.target) || findDOMNode(this.refsMap.optionsWrap);

    if (this.state.isOpen && scrollWrapperNode) {
      this.setState({
        hasTopShadow: scrollWrapperNode.scrollTop > 0,
      });
    } else {
      this.setState({
        hasTopShadow: false,
      });
    }
  };

  setRefs = setRefs(this);

  setRefOptionsWrap = this.setRefs('optionsWrap');

  setRefItemsList = this.setRefs('itemsList');

  setDropdownRef = this.setRefs('dropdown');

  setControlRef = this.setRefs('control');

  render() {
    const { isOpen, hasTopShadow } = this.state;

    const { items, valid, touched } = this.props;

    const onScrollHandler = items && items.length > 3 ? this.setDropdownShadowsState : null;

    const optionsNodes = this.getOptions();

    const optionsListNode = optionsNodes ? (
      <div
        className={cx('items', {
          hasTopShadow: hasTopShadow,
        })}
        tabIndex="-1"
      >
        <div
          className={cx('scrollWrapper')}
          ref={this.setRefOptionsWrap}
          onScroll={onScrollHandler}
          tabIndex="-1"
        >
          <div className={cx('list')} ref={this.setRefItemsList} tabIndex="-1">
            {optionsNodes}
          </div>
        </div>
      </div>
    ) : null;

    const overlayNode =
      isOpen && optionsNodes.length ? (
        <div
          className={cx('overlay', {
            isOpen,
          })}
          tabIndex="-1"
        >
          {optionsListNode}
        </div>
      ) : null;

    return (
      <div className={cx('CardAutocomplete')} ref={this.setDropdownRef}>
        <InputWithRef
          {...this.getTriggerProps()}
          autoFocus={true}
          ref={this.setControlRef}
          isError={!valid && touched}
        />
        {overlayNode}
      </div>
    );
  }
}

CardAutocomplete.defaultProps = {
  ...Autocomplete.defaultProps,
  autoSelectIfOne: false,
  activeFirst: false,
  skipActive: true, // Warn течет память при false
  valueKey: 'number',
};

export default CardAutocomplete;
